import { parseDate } from '@artup/utilities'
import { Assignable } from './assignable'

const parseIdentifier = value => {
  if (value == null) return undefined
  const num = Number(value)
  return isNaN(num) ? value : num
}

/**
 * Basic database entity
 */
export class Entity extends Assignable {
  constructor (data = {}) {
    super(data)
    this.assign(data, {
      id: parseIdentifier,
      createdBy: parseIdentifier,
      updatedBy: parseIdentifier,
      deletedBy: parseIdentifier,
      created: parseDate,
      updated: parseDate,
      deleted: parseDate
    })
  }

  normalize () {
    super.normalize()
    this.created = parseDate(this.created, new Date())
    this.updated = parseDate(this.updated, new Date())
    if (this.deleted) {
      this.deleted = parseDate(this.deleted)
    }
  }

  /**
   * New entity identifier constant
   */
  static ID_NEW = 'new'

  /**
   * Returns the type of the specified entity
   * @param entity Entity whose type to return
   */
  getTypeOf (entity) {
    if (entity != null) {
      return entity.constructor ? entity.constructor.name.toLowerCase() : typeof entity
    }
  }

  /**
   * Returns the type of this entity
   */
  getType () {
    if (this.constructor) {
      return this.constructor.name.toLowerCase()
    }
  }

  /**
   * Database identifier
   * @type {Number}
   */
  id

  /**
   * Indicates a new entity
   * @type {Boolean}
   */
  get isNew () {
    return !this.id || this.id === Entity.ID_NEW
  }

  /**
   * Entity name
   * @type {String}
   */
  name

  /**
   * Full name, often overridden in descendants
   * to include things such as profile name etc.
   * @type {String}
   */
  get fullName () {
    return this.name
  }

  /**
   * Creation time
   * @type {Date}
   */
  created

  /**
   * Last modification time
   * @type {Date}
   */
  updated

  /**
   * Deletion time
   * @type {Date}
   */
  deleted

  /**
   * Creator account identifier
   * @type {Number}
   */
  createdBy

  /**
   * Updater account identifier
   * @type {Number}
   */
  updatedBy

  /**
   * Indicates that entity is/should be deleted
   * @type {Boolean}
   */
  isDeleted

  /**
   * Deleter account identifier
   * @type {Number}
   */
  deletedBy
}
